import * as XLSX from "xlsx";

export const exportTreatmentExcel = (rows, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Demandes");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
